var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cover-component'),(_vm.$store.state.start)?_c('shelf-chart'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }